import './index.scss';
import React from 'react';
import {
    //GECKO_CONSTS,
    GeckoModal,
    GeckoModalService
} from '@geckolabs/gecko-react-ui';

import WebinarService from '../../services/Webinar';
import { __, STR_KEY } from '../../services/Translate';
import HtmlWrapper from '../HtmlWrapper';

const WebinarModal = ({url, description}) => {
    const btns = [{
        name: __(STR_KEY.MODAL_WEBINAR_BTN_NO),
        preset: 'close',
        secondary: true,
        handler: () => new GeckoModalService().close()
    }, {
        name: __(STR_KEY.MODAL_WEBINAR_BTN_YES),
        preset: 'actions',
        icon: 'video',
        primary: true,
        handler: () => WebinarService.openUrl(url)
    }];

    const content = description ? description : `<p>${__(STR_KEY.MODAL_WEBINAR_CONTENT_DEFAULT)}</p>`;
    
    return (
        <div className="WebinarModal">
            <GeckoModal name={__(STR_KEY.MODAL_WEBINAR_TITLE)} hideModalClose={true} btns={btns}>
                <HtmlWrapper html={content} />
            </GeckoModal>
        </div>
    );
}

export default WebinarModal;